export default {
    "festiware": {
        'repeater': {
            'is_owner_person': 'Is contact person',
            'is_owner_person_hint': '<div class="uk-alert uk-alert-primary uk-margin-remove-bottom">Please note that the necessary personal information is taken from the contact form. If you have not yet entered it, you may be asked for it in the next step.</div>',
            'add': 'Add person',
            'change_owner_person': '<div class="uk-flex"><div class="uk-width-small"><i uk-icon="icon:warning; ratio:2"></i></div><div>Please note that changing the contact person means that you will no longer be able to access this form after saving!</div>',
            'bulk_upload': {
                'toggle': 'Import people from a CSV/Excel file',
                'button': 'Upload list',
                'template': 'Download template',
                'template_filename': 'import-template',
                'hint': 'Add several people from a CSV or Excel file instead of entering them one by one.',
                'phone_hint': 'Enter phone numbers with a leading 0 (e.g. 0160 1234567) or with a country code (e.g. +49 160 1234567) — spaces are allowed. To keep Excel from stripping the + or the leading 0, format the phone column as text or save the file as CSV.',
                'imported': ':count row(s) added. Please check the details and submit the form.',
                'unmatched': 'Unmatched columns: :columns.',
                'unmatched_values': 'Column “:field”: the values :values match no available option and remain empty. Allowed: :options.',
                'limit': ':skipped row(s) were not added — the maximum number (:max) has been reached.',
                'limit_full': 'The maximum number (:max) has already been reached. No rows were added.',
                'empty': 'The file contains no usable rows.',
                'error': 'The file could not be read. Please use a CSV or Excel file.',
                'progress_reading': 'Reading file …',
                'progress_importing': 'Importing people … (:done of :total)'
            }
        },
        'use_stored_data': 'We noticed that you have already started the form. Do you want to continue?',
        'yes': 'Yes',
        'no': 'No',
        'update_success_default': 'Your details have been saved successfully.',
        'selfie': {
            'select': 'Choose image',
            'camera': 'Capture with camera',
            'camera_starting': 'Starting camera …',
            'camera_label': 'Camera',
            'capture': 'Take photo',
            'cancel': 'Cancel',
            'confirm': 'Use this crop',
            'discard': 'Discard',
            'zoom': 'Zoom',
            'reset': 'Reset',
            'ratio': 'Aspect ratio:',
            'hint': 'Drag to move and zoom the image — this crop is what gets stored.',
            'camera_not_ready': 'The camera is not delivering an image yet. Please wait a moment and try again.',
            'camera_denied': 'Camera access was denied. Please allow it for this page in the browser.',
            'camera_missing': 'No camera was found.',
            'camera_busy': 'The camera is in use — please close other programs using it.',
            'camera_failed': 'The camera could not be started.',
            'crop_failed': 'The image crop could not be created.',
        },
        'calendar': {
            'text': 'You can subscribe to your always up-to-date appointments in your calendar app via the following link:',
            'link': 'Calendar Subscription URL',
        },
        'errors': {
            'owner_person_not_defined' :'No contact person was specified. Please adjust the information in the person fields accordingly.',
            'update_request_target_missing': 'The group to be edited could not be identified. Please reopen the form from the specific group in the portal, or contact the organiser.',
            'not_valid_for_group': 'This group cannot be edited with the current login. Please open the form from the relevant group in the portal, or contact the organiser.',
            'person_deactivated': 'Access to the portal has been deactivated, so these details can no longer be changed. Please contact the organiser if this is a mistake.',
            'events_maximum_selection_exceeded': 'More dates were selected than allowed. Please reduce the selection and save again.',
            'tab_hint': 'There is still missing information for',
            'tab_hint_buttons': {'ok': 'Got it'},
            'generic_error': 'An error occurred. Please try again later.',
        },
        'tabs': {
            'scrollLeft': 'Scroll tabs left',
            'scrollRight': 'Scroll tabs right',
            'offscreenErrors': 'Errors',
            'errorBadge': 'Error',
            'save': 'Save',
            'saving': 'Saving…',
        },
        'steps': {
            'scrollLeft': 'Scroll steps left',
            'scrollRight': 'Scroll steps right',
            'offscreenErrors': 'Errors',
            'errorBadge': 'Error',
        },
        'no_visible_fields': 'No fields are currently available for editing.',
        'uploading_files': 'Uploading :count file(s). Please wait…',
        'upload_failed': 'Upload failed. Please try again.',
        'events': {
            'no_events': 'No events available',
            'not_available': 'No longer available',
            'free_slots': ':count free slots',
            'only_one_place': 'You can only select events in one location, not multiple.',
            'maximum_reached': 'You have already selected the maximum number of events.',
            'minimum_not_met': 'Please select at least :min events before saving.',
            'selection_hint_exact': 'Select exactly :min events (:selected selected)',
            'selection_hint_min': 'Select at least :min events (:selected selected)',
            'selection_hint_max': 'Select at most :max events (:selected selected)',
            'selection_hint_range': 'Select between :min and :max events (:selected selected)',
            'date': 'Date',
            'datetime': 'Date & Time',
            'duration': 'Duration',
            'save': 'Save'
        }
    },
    "validation": {
        "phoneNumber": "This is not a valid phone number format.",
        "dateText": "Please enter a complete date in the format DD.MM.YYYY.",
    },
}
